import type { DeepStrings } from "@rekati/i18n";
import type { Dict } from "./en";

export const id: DeepStrings<Dict> = {
  meta: {
    skip: "Lewati ke konten",
    language: "Bahasa",
    languageName: "Bahasa Indonesia",
    switchTo: "English",
    home: "Beranda",
    backHome: "Kembali ke beranda",
  },
  brand: {
    organisedBy: "Diselenggarakan oleh",
    poweredBy: "Didukung oleh",
  },
  hero: {
    eventName: "Memperkuat Masa Depan Layanan Kesehatan",
    register: "Daftar sekarang",
    signIn: "Sudah terdaftar? Masuk",
    when: "Waktu",
    where: "Tempat",
    tbc: "Menyusul",
    openMap: "Buka di Maps",
    time: "{start} – {end} WIB",
    admit: "Tiket masuk",
    daysToGo: "{n} hari lagi",
    tomorrow: "Besok",
    countdown: "Hitung mundur menuju pintu dibuka",
    days: "hari",
    hours: "jam",
    minutes: "mnt",
    seconds: "dtk",
  },
  nav: {
    label: "Di halaman ini",
    about: "Tentang",
    theme: "Tema",
    speakers: "Pembicara",
    perks: "Di hari acara",
    venue: "Lokasi",
    register: "Daftar",
  },
  about: {
    kicker: "Tentang",
    speakers: "pembicara di panggung",
    hours: "jam, satu pagi",
    prizeValue: "Doorprize",
    prize: "Doorprize Menarik",
  },
  theme: {
    kicker: "Tema",
    title: "Tiga gagasan, dalam satu pagi",
  },
  speakers: {
    kicker: "Pembicara",
    title: "Siapa yang akan berbicara",
    photoSoon: "Foto menyusul",
    orgs: {
      bpjs: "BPJS Kesehatan",
      osi: "Orang Siber Indonesia",
    },
  },
  perks: {
    kicker: "Di hari acara",
    title: "Datang untuk sesinya. Pulang membawa lebih.",
    merchTitle: "Dapatkan Merchandise Exclusive Pagelaran Sabang Merauke",
    prizeTitle: "Doorprize Menarik",
    prizeCard: "Doorprize",
  },
  venue: {
    kicker: "Lokasi",
    title: "Sampai jumpa di sini",
    openMap: "Buka di Google Maps",
    openMapLabel: "Buka {place} di Google Maps",
    mapTitle: "Peta lokasi acara",
  },
  closing: {
    kicker: "Amankan kursi Anda",
    title: "Kami tunggu kehadiran Anda.",
    body: "Pendaftaran kira-kira satu menit. QR untuk pintu masuk dikirim lewat email.",
  },
  contact: {
    kicker: "Ada pertanyaan?",
    body: "Untuk info lebih lanjut, hubungi {name}.",
    bodyWithPhone: "Untuk info lebih lanjut, hubungi {name} di {phone}.",
    whatsapp: "Chat lewat WhatsApp",
  },
  flow: {
    start: "Ayo daftarkan diri Anda",
    startBody:
      "{n} pertanyaan singkat, sekitar satu menit. Paket peserta berisi QR untuk masuk dikirim lewat email.",
    begin: "Mulai",
    packByEmail: "QR masuk lewat email",
    duration: "Sekitar 1 menit",
    pressEnter: "tekan Enter",
    ok: "OK",
    next: "Lanjut",
    back: "Pertanyaan sebelumnya",
    nextQuestion: "Pertanyaan berikutnya",
    progress: "Pertanyaan {current} dari {total}",
    required: "Wajib",
    optional: "opsional",
    yes: "Ya",
    no: "Tidak",
    typeHere: "Ketik jawaban Anda di sini…",
    sending: "Mengirim…",
    saving: "Menyimpan…",
    checking: "Memeriksa…",
    stepAccount: "Akun",
    stepCode: "Verifikasi",
    stepProfile: "Profil",
    q: {
      full_name: {
        title: "Siapa nama lengkap Anda?",
        hint: "Sesuai yang akan tertulis di paket peserta Anda.",
      },
      phone: {
        title: "Nomor HP Anda?",
      },
      email: {
        title: "Lalu alamat email Anda?",
        hint: "Kode verifikasi dan paket peserta dikirim ke sini.",
      },
      code: {
        title: "Masukkan kode 6 digit",
        hint: "Kami mengirimnya ke {email}. Bisa butuh satu menit; cek juga folder spam.",
        label: "Kode verifikasi",
        digit: "Digit {n} dari 6",
        resend: "Kirim kode baru",
        resendIn: "Kode baru dalam {s} dtk",
        resent: "Kode baru sedang dikirim. Gunakan email yang terbaru.",
        wrongEmail: "Alamat salah? Ubah",
        attempts: "Sisa {n} percobaan.",
      },
      identity_type: {
        title: "Mana yang paling menggambarkan Anda?",
        brand_owner: "Saya punya usaha",
        creative_worker: "Saya bekerja di bidang kreatif",
        professional: "Saya seorang profesional",
      },
      company_name: {
        title: "Di institusi mana Anda bekerja?",
        hint: "Rumah sakit, klinik, atau organisasi.",
      },
      job_title: { title: "Apa jabatan Anda?" },
      community_member: {
        title: "Apakah Anda merupakan member dari {community}?",
        titleGeneric: "Apakah Anda anggota komunitas mitra?",
      },
      personal_instagram: { title: "Akun Instagram Anda?" },
      how_heard: { title: "Dari mana Anda mengetahui acara ini?" },
      what_excites_you: { title: "Apa yang ingin Anda bawa pulang dari acara ini?" },
      industry: {
        title: "Anda bergerak di sektor apa?",
        other: "Lainnya",
        otherPlaceholder: "Sebutkan sektor Anda",
      },
      interests: {
        title: "Topik apa yang Anda minati?",
        hint: "Pilih sebanyak yang Anda mau.",
        other: "Lainnya",
        otherPlaceholder: "Sebutkan topiknya",
      },
      brand_name: { title: "Apa nama usaha Anda?" },
      about_brand: { title: "Ceritakan tentang usaha Anda." },
      brand_instagram: { title: "Akun Instagram usaha Anda?" },
      consent: {
        title: "Satu hal terakhir",
        body: "Saya menyetujui pengumpulan, penyimpanan, dan pemrosesan data pribadi yang saya berikan oleh iForte untuk keperluan pengelolaan pendaftaran, verifikasi identitas, administrasi keikutsertaan, serta penyampaian informasi dan komunikasi terkait acara ini. Data saya akan dikelola secara aman dan digunakan sesuai dengan ketentuan perlindungan data pribadi yang berlaku.",
        agree: "Saya setuju",
      },
    },
    choiceKey: "Tombol {key}",
    done: {
      kicker: "Anda sudah terdaftar",
      title: "Kami tunggu kehadiran Anda.",
      body: "Paket peserta Anda sedang dikirim ke {email}: QR untuk masuk dalam PDF, dan file kalender untuk hari acara.",
      noEmail: "Belum ada email dalam 10 menit? Cek folder spam, atau hubungi {name}.",
      addToCalendar: "File kalender ada di dalam email",
      qr: "Tunjukkan QR dari PDF di meja registrasi pada hari acara.",
      manage: "Lihat pendaftaran saya",
      home: "Kembali ke halaman acara",
    },
  },
  returning: {
    kicker: "Sudah terdaftar",
    title: "Masuk dengan email Anda",
    body: "Gunakan alamat yang sama dengan saat mendaftar. Kami akan mengirim kode ke sana.",
    email: "Alamat email",
    send: "Kirimi saya kode",
    sent: "Jika email itu terdaftar, kami sudah mengirim kode. Gunakan alamat yang sama dengan saat mendaftar.",
    code: "Kode",
    verify: "Masuk",
    another: "Pakai email lain",
    newCode: "Kirim kode baru",
    notRegistered: "Belum terdaftar?",
    registerInstead: "Daftar sekarang",
  },
  account: {
    loading: "Memuat pendaftaran Anda",
    hello: "Halo, {name}",
    status: "Pendaftaran",
    packSent: "Paket peserta Anda sudah dikirim ke {email}.",
    packPending: "Lengkapi profil Anda dan paket peserta akan dikirim ke {email}.",
    complete: "Lengkapi profil saya",
    profile: "Data Anda",
    edit: "Ubah data",
    language: "Bahasa email",
    languageHint:
      "Pengingat dan semua email berikutnya akan memakai bahasa ini. Email yang sudah terkirim tidak berubah.",
    languageSaved: "Tersimpan. Email berikutnya akan dalam {lang}.",
    signOut: "Keluar",
    institution: "Institusi",
    position: "Jabatan",
    community: "Member {community}",
    phone: "Nomor HP",
    email: "Email",
    notAnswered: "Belum dijawab",
    saved: "Data Anda tersimpan.",
    save: "Simpan data",
    cancel: "Batal",
  },
  rsvp: {
    kicker: "Sesi",
    title: "Pilih sesi Anda",
    join: "Ikut",
    joinWaitlist: "Masuk daftar tunggu",
    leave: "Batal",
    full: "Penuh",
    spots: "Sisa {n} kursi",
    noLimit: "Tanpa batas",
    allDay: "Buka sepanjang hari",
    tbd: "Waktu menyusul",
    capacityTbd: "Segera dibuka",
    cancelled: "Dibatalkan",
    waitlisted: "Daftar tunggu, urutan {n}",
    confirmed: "Anda terdaftar",
    overlap: "Bentrok dengan {sessions}.",
    closed: "Pemilihan sesi sudah ditutup.",
    submit: "Kirim pilihan sesi",
    saveChanges: "Simpan perubahan",
    outcome: {
      pack_queued: "Terkirim. Pass Anda sedang dikirim ke {email}.",
      update_queued: "Diperbarui. Pass baru sedang dikirim.",
      already_queued: "Sudah dalam perjalanan.",
      unchanged: "Tidak ada perubahan.",
    },
  },
  walkIn: {
    title: "Registrasi walk-in",
    body: "Belum mendaftar? Jawab {n} pertanyaan singkat dan Anda langsung check-in, tanpa kode email.",
    chip: "Langsung check-in",
    emailHint: "Untuk informasi acara. Tidak ada kode yang dikirim.",
    emailTaken: "Email ini sudah terdaftar. Tunjukkan QR dari email Anda di meja registrasi, atau sebutkan nama Anda.",
    closedTitle: "Registrasi walk-in ditutup",
    closedBody: "Formulir ini dibuka pada hari acara, di lokasi. Sebelum itu, silakan daftar online.",
    toRegister: "Daftar online",
    home: "Kembali ke acara",
    inTitle: "Anda sudah check-in",
    againTitle: "Anda sudah check-in sebelumnya",
    inAt: "Check-in pukul {time}",
    inBody: "Silakan tunjukkan layar ini ke petugas meja registrasi, lalu masuk setelah diverifikasi oleh petugas.",
    registeredTitle: "Anda sudah terdaftar",
    registeredBody: "Nomor ini sudah terdaftar, jadi tidak ada yang diubah. Tunjukkan QR dari email Anda di meja registrasi, atau sebutkan nama Anda dan petugas akan melakukan check-in.",
  },

  survey: {
    title: "Survei & Merchandise",
    body: "Gunakan alamat email atau nomor HP yang Anda pakai saat mendaftar.",
    identifierLabel: "Email atau nomor HP",
    continue: "Lanjut",
    loading: "Memuat survei",
    notOpenYet: "Survei belum dibuka",
    opensAt: "Dibuka {date}, pukul {time} WIB.",
    closed: "Survei belum dibuka / sudah ditutup",
    window: "Dibuka {start} – {end} WIB.",
    answeredBefore: "Sudah mengisi? Masukkan email atau nomor HP Anda untuk melihat QR Anda lagi.",
    notRegistered:
      "Maaf, akun Anda belum terdaftar di sistem kami. Jika Anda merasa ini adalah kesalahan, silakan hubungi administrator atau meja registrasi untuk mendapatkan bantuan.",
    notVerified:
      "Pendaftaran Anda belum selesai: konfirmasi email Anda dengan kode yang kami kirim, lalu coba lagi.",
    toRegister: "Ke halaman pendaftaran",
    notReady: "Survei belum siap. Silakan coba lagi sebentar lagi.",
    identifierInvalid: "Masukkan alamat email atau nomor HP yang valid.",
    rateLimited: "Terlalu banyak percobaan. Mohon tunggu sebentar lalu coba lagi.",
    rateLimitedFor: "Terlalu banyak percobaan. Mohon tunggu {s} detik lalu coba lagi.",
    greeting: "Halo, {first_name}!",
    requiredLegend: "Pertanyaan bertanda * wajib dijawab.",
    requiredMark: "wajib",
    ratingValue: "{n} dari {max}",
    characters: "{n}/{max}",
    answerRequired: "Mohon jawab pertanyaan ini.",
    answerInvalid: "Mohon periksa jawaban ini.",
    answerTooLong: "Jawaban ini terlalu panjang.",
    otherLabel: "Sebutkan",
    otherPlaceholder: "Tuliskan jawaban Anda…",
    otherRequired: "Mohon sebutkan jawaban Anda untuk pilihan ini.",
    fixAnswers: "Beberapa jawaban perlu diperiksa.",
    submit: "Kirim jawaban",
    confirm: "Jawaban tidak dapat diubah setelah dikirim. Kirim sekarang?",
    review: "Periksa lagi",
    qrInstruction: "Tunjukkan QR ini di meja registrasi untuk mengambil merchandise",
    qrAlt: "Kode QR merchandise",
    saveImage: "Simpan sebagai gambar",
    saveHint: "Tekan dan tahan gambar untuk menyimpannya",
    alreadySubmitted: "Anda sudah mengisi survei sebelumnya; ini QR Anda.",
    alreadyCollected: "Merchandise sudah diambil",
    collectedAt: "{date}, pukul {time} WIB",
    notYou: "Bukan Anda? Gunakan email atau nomor lain",
  },
  toast: {
    close: "Tutup",
    codeSent: "Kode terkirim",
    codeSentBody: "Cek {email}. Bisa butuh satu menit untuk sampai.",
    codeResent: "Kode baru sedang dikirim",
    codeResentBody: "Gunakan kode di email terbaru.",
    serverDown: "Server kami tidak bisa dihubungi",
    saved: "Tersimpan",
    signedOut: "Anda sudah keluar",
  },
  errors: {
    generic: "Terjadi kesalahan. Silakan coba lagi.",
    network: "Tidak dapat terhubung ke server. Periksa koneksi Anda lalu coba lagi.",
    unreachable:
      "Server kami sedang tidak merespons. Jawaban Anda tetap tersimpan di sini; silakan coba lagi sebentar lagi.",
    timeout: "Server terlalu lama menjawab. Silakan coba lagi.",
    rateLimited: "Terlalu banyak percobaan. Tunggu {s} detik.",
    rateLimitedShort: "Terlalu banyak percobaan. Tunggu sebentar.",
    retry: "Coba lagi",
    required: "Mohon jawab pertanyaan ini.",
    fullName: "Mohon isi nama lengkap Anda.",
    phoneInvalid: "Sepertinya itu bukan nomor HP Indonesia.",
    emailInvalid: "Mohon isi alamat email yang valid.",
    emailTaken: "Email ini sudah terdaftar. Masuk dengan email ini untuk mengelola pendaftaran Anda.",
    signInInstead: "Masuk saja",
    codeShape: "Kodenya 6 digit.",
    codeWrong: "Kode itu tidak tepat.",
    codeExpired: "Kode ini sudah kedaluwarsa. Kirim kode baru.",
    codeLocked: "Terlalu banyak kode salah. Kirim kode baru.",
    codeSuperseded: "Kode yang lebih baru sudah dikirim. Gunakan kode di email terbaru.",
    codeConsumed: "Kode ini sudah dipakai. Masuk untuk melanjutkan.",
    challengeGone: "Pendaftaran ini sudah kedaluwarsa. Silakan mulai lagi.",
    resendLimit: "Anda sudah meminta banyak kode. Tunggu satu jam lalu coba lagi.",
    phoneConflict: "Nomor ini tidak bisa dipakai untuk pendaftaran ini. Silakan mulai lagi.",
    consentRequired: "Mohon setujui untuk melanjutkan.",
    tooLong: "Terlalu panjang. Mohon dipersingkat.",
    sessionExpired: "Sesi Anda sudah berakhir. Silakan masuk lagi.",
    eventNotReady: "Pendaftaran belum dibuka. Silakan cek lagi nanti.",
    startOver: "Mulai lagi",
  },
  notFound: {
    title: "Halaman ini tidak ada",
    body: "Tautannya mungkin sudah lama. Semua info ada di halaman acara.",
    home: "Ke halaman acara",
  },
};
